import { put, takeEvery } from 'redux-saga/effects';
import { IAvailableArchitectureType } from '../../models/MigrateModels';
import {
  ConfigureArchitectureAction,
  ConfigureArchitectureActionTypes,
  ConfigureArchitectureActions,
} from '../actions/ConfigureArchitectureActions';
import configureArchitectureService from '../../services/ConfigureArchitectureService';
import { IRowsData } from '../../../pages/Migrate/DiscoverTab/EditableTable';
import { IMigrateVMPayload, ISourceDataPayload, ITargetDataPayload } from '../../models/ConfigureArchitectureModels';

export function* sendSourceDataWorker(action: ConfigureArchitectureAction) {
  try {
    // ToDo: Make API Call for SAP sending Source Data
    const response: IRowsData[] = (yield configureArchitectureService.sendSourceTableData(
      action.data as ISourceDataPayload,
    ))!;
    yield put(ConfigureArchitectureActions.sendSourceDataSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(ConfigureArchitectureActions.sendSourceDataError(error));
    }
  }
}
export function* getSummaryDataWorker(action: ConfigureArchitectureAction) {
  try {
    // ToDo: Make API Call for SAP sending Source Data
    const response: IRowsData[] = (yield configureArchitectureService.getSummaryData(
      action.data as ISourceDataPayload,
    ))!;
    yield put(ConfigureArchitectureActions.getSummaryDataSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(ConfigureArchitectureActions.getSummaryDataError(error));
    }
  }
}
export function* getSourceDataWorker(action: ConfigureArchitectureAction) {
  try {
    // ToDo: Make API Call for SAP getting Source Data
    const response: IRowsData[] = (yield configureArchitectureService.getSourceTableData(
      action.data as ISourceDataPayload,
    ))!;
    yield put(ConfigureArchitectureActions.getSourceDataSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(ConfigureArchitectureActions.getSourceDataError(error));
    }
  }
}
export function* updateSourceDataWorker(action: ConfigureArchitectureAction) {
  try {
    // ToDo: Make API Call for SAP getting Source Data
    const response: IRowsData[] = (yield configureArchitectureService.updateSourceTableData(
      action.data as ISourceDataPayload,
    ))!;
    yield put(ConfigureArchitectureActions.updateSourceDataSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(ConfigureArchitectureActions.updateSourceDataError(error));
    }
  }
}
export function* sendTargetDataWorker(action: ConfigureArchitectureAction) {
  try {
    const response: IRowsData[] = (yield configureArchitectureService.sendTargetTableData(
      action.data as ITargetDataPayload,
    ))!;
    yield put(ConfigureArchitectureActions.sendTargetDataSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(ConfigureArchitectureActions.sendSourceDataError(error));
    }
  }
}
export function* getTargetDataWorker(action: ConfigureArchitectureAction) {
  try {
    const response: IRowsData[] = (yield configureArchitectureService.getTargetTableData(
      action.data as ITargetDataPayload,
    ))!;
    yield put(ConfigureArchitectureActions.getTargetDataSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(ConfigureArchitectureActions.getSourceDataError(error));
    }
  }
}
export function* updateTargetDataWorker(action: ConfigureArchitectureAction) {
  try {
    const response: IRowsData[] = (yield configureArchitectureService.updateTargetTableData(
      action.data as ITargetDataPayload,
    ))!;
    yield put(ConfigureArchitectureActions.updateTargetDataSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(ConfigureArchitectureActions.updateSourceDataError(error));
    }
  }
}

export function* migrateVMWorker(action: ConfigureArchitectureAction) {
  try {
    const response: IRowsData[] = (yield configureArchitectureService.migrateVM(
      action.data as IMigrateVMPayload,
    ))!;
    yield put(ConfigureArchitectureActions.migrateVMSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(ConfigureArchitectureActions.migrateVMError(error));
    }
  }
}

export function* sendSourceDataWatcher() {
  yield takeEvery(ConfigureArchitectureActionTypes.SEND_SOURCE_DATA_START, sendSourceDataWorker);
  yield takeEvery(ConfigureArchitectureActionTypes.GET_SUMMARY_DATA_START, getSummaryDataWorker);
  yield takeEvery(ConfigureArchitectureActionTypes.GET_SOURCE_DATA_START, getSourceDataWorker);
  yield takeEvery(ConfigureArchitectureActionTypes.GET_TARGET_DATA_START, getTargetDataWorker);
  yield takeEvery(
    ConfigureArchitectureActionTypes.UPDATE_SOURCE_DATA_START,
    updateSourceDataWorker,
  );
  yield takeEvery(
    ConfigureArchitectureActionTypes.UPDATE_TARGET_DATA_START,
    updateTargetDataWorker,
  );
  yield takeEvery(ConfigureArchitectureActionTypes.SEND_TARGET_DATA_START, sendTargetDataWorker);
  yield takeEvery(ConfigureArchitectureActionTypes.MIGRATE_VM_START, migrateVMWorker);
}
